// src/slideData.js
export const slides = [
  { type: 'image', src: require('../../images/image1.jpeg'), alt: 'First Slide', duration: 5 },
  { type: 'video', src: require('../../images/video1.mov') },
  { type: 'image', src: require('../../images/image2.jpg'), alt: 'Third Slide', duration: 5 },
  { type: 'video', src: require('../../images/video2.mp4') },
];
